// initial state
const state = {
  toplistByRange: {
    day: [],
    week: [],
    month: []
  },
  updatedAtByRange: {
    day: null,
    week: null,
    month: null
  }
}

// getters
const getters = {
  playtimeToplistByRange: state => state.toplistByRange,
  playtimeUpdatedAtByRange: state => state.updatedAtByRange
}

// actions
const actions = {
  getPlaytimeToplist ({ commit }, payload) {
    commit('setPlaytimeToplist', payload.data)
  },
  updatePlaytimeToplist ({ commit }, payload) {
    commit('updatePlaytimeToplist', payload.data)
  }
}

// mutations
const mutations = {
  setPlaytimeToplist (state, toplist) {
    const payload = Array.isArray(toplist) ? { range: 'day', rows: toplist } : (toplist || {})
    const range = (payload.range || 'day').toLowerCase()
    const rows = payload.rows || []
    state.toplistByRange[range] = rows
    state.updatedAtByRange[range] = Date.now()
  },
  updatePlaytimeToplist (state, payload) {
    if (!payload) return
    const range = (payload.range || 'day').toLowerCase()
    const rows = Array.isArray(payload) ? payload : (payload.rows || [])
    const removed = payload.removed || []
    const keyOf = (row) => `${(row.server || '').toLowerCase()}|${(row.username || '').toLowerCase()}`

    const map = new Map((state.toplistByRange[range] || []).map(item => [keyOf(item), item]))
    removed.forEach(key => {
      if (key) map.delete(key)
    })
    rows.forEach(row => {
      if (!row) return
      map.set(keyOf(row), row)
    })

    state.toplistByRange[range] = Array.from(map.values()).sort((a, b) => {
      const am = a.yesterday_minutes || 0
      const bm = b.yesterday_minutes || 0
      return bm - am
    })
    state.updatedAtByRange[range] = Date.now()
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
